<template>
  <div class="nav-bar" :style="{background:this.$root.colorController}">

    <img class="logo" :src="logoPath" alt="">

    <!-- <el-dropdown class="dropdown">
      <a>
        <img style="height:25px; width: 25px;" src="../../../assets/img/color/red.png" alt="向下" />
        <i class="arrow el-icon-arrow-down" style="margin-top: 6px;"></i>
      </a>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit-outline" @click.native="formVisable = true">修改密码</el-dropdown-item>
        <el-dropdown-item icon="el-icon-unlock" @click.native="logout()">注销</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->

    <el-dropdown class="dropdown" :style="{color:(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')}">
      <a>
        <i class="user el-icon-user-solid"></i>
        {{name}}
        <i class="arrow el-icon-arrow-down"></i>
      </a>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit-outline" @click.native="formVisable = true">修改密码</el-dropdown-item>
        <el-dropdown-item icon="el-icon-unlock" @click.native="logout()">注销</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown class="dropdown-color" :style="{color:(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')}">
      <a>
        <span v-if="colConFalg === false">
         <img style="height:20px; width: 20px; margin-right: 5px; margin-top: -5px;" src="../../../assets/img/color/clothes.png" alt="白" />
        </span>

        <span v-else>
         <img style="height:20px; width: 20px; margin-right: 5px;margin-top: -5px;" src="../../../assets/img/color/clothes-black.png" alt="黑" />
        </span>


        <i class="arrow el-icon-arrow-down" style="margin-top: 6px;"></i>
      </a>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="changeColor('#cecece')">
          <img style="height:25px; width: 25px;" src="../../../assets/img/color/grey.png" alt="灰色" />
        </el-dropdown-item>
        <el-dropdown-item @click.native="changeColor('#000')">
          <img style="height:25px; width: 25px;" src="../../../assets/img/color/black.png" alt="黑色" />
        </el-dropdown-item>
        <el-dropdown-item @click.native="changeColor('#e0620d')">
          <img style="height:25px; width: 25px;" src="../../../assets/img/color/orange.png" alt="红色" />
        </el-dropdown-item>
        <el-dropdown-item @click.native="changeColor('#00ff00')">
          <img style="height:25px; width: 25px;" src="../../../assets/img/color/green.png" alt="绿色" />
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 弹出编辑框 -->
    <el-dialog title="修改密码" :visible.sync="formVisable">
      <el-form :model="form">
        <el-form-item label="请输入新密码" label-width="120px">
          <el-col :span="12">
            <el-input v-model="form.newPassword" show-password placeholder="请输入新密码"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="请再次输入密码" label-width="120px">
          <el-col :span="12">
            <el-input v-model="form.rePassword" show-password placeholder="请再次输入密码"></el-input>
          </el-col>
        </el-form-item>
      </el-form>

      <div slot="footer" class="footer">
        <el-button @click="formVisable = false">取消</el-button>
        <el-button type="primary" @click="formSub()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as types from '@/store/mutation-types'
  import {
    doLogout
  } from '@/api/login'

  export default {
    name: 'NavBar',
    components: {

    },

    data() {
      return {
        name: this.$store.getters['user/userName'],
        formVisable: false,
        form: {
          newPassword: '',
          rePassword: ''
        },
        colConFalg:false,
        rules: {

        }
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('user/logout').then(res => {
          // 注销成功
          this.$router.push('/login')
        })
      },

      changeColor(val) {
        this.$root.colorController = val
        if(val == '#000'){
          this.colConFalg = false;
        } else {
          this.colConFalg = true;
        }
      },

      formSub() {
        this.inputValidate()
        this.formVisable = false
      },


    },
    props: {
      logoPath: {
        type: String
      }
    }
  }
</script>

<style scoped>
  .nav-bar {
    position: relative;
    padding: 0 20px;
    /* background: #000000; */

  }

  .logo {
    position: absolute;
    bottom: 5px;
    height: 30px;
  }

  .dropdown {
    float: right;
    width: 115px;
    height: 100%;
    /* color: #ffffff; */
    /* background: rgba(255,255,255,.1); */
  }

  .dropdown-color {
    float: right;
    width: 45px;
    top: 8px;
    height: 100%;
    /* color: #ffffff; */
  }

  .dropdown .down-button {
    width: 100%;
    height: 100%;
  }

  .dropdown i {
    text-align: center;
    line-height: 30px;
  }

  .dropdown .user {
    width: 30px;
    height: 30px;
    margin: 5px 0 5px 5px;
    background: rgba(255, 255, 255, .1);
    font-size: 20px;
  }

  .dropdown .arrow {
    width: 20px;
    height: 10px;
    font-size: 14px;
  }

  .el-dropdown-menu_item {
    padding: 6px 0 6px 13px;
  }
</style>
